export const PAYMENTS = {
	monjaro_flagship_se: '45 000',
	cityray: '25 000',
	coolray: '25 000',
	okavango: '35 000',
	ex5: '35 000',
	nordcross_001: '',
	'ex5_em-i': '',
	atlas_new: '',
	preface: '25 000'
};

export const BENEFITS = {
	atlas_pro: "900 000",
	okavango: "1 200 000",
	tugella: "680 000",
	coolray: "800 000",
	atlas_new: "985 000",
	atlas: "390 000",
	monjaro: "1 420 000",
	monjaro_flagship_se: "1 420 000",
	preface: "850 000",
	cityray: "1 200 000",
	emgrand: "750 000",
	monjaro_hybrid: "1 000 000",
	ex5: '400 000',
	'ex5_em-i': "900 000",
	nordcross_001: "500 000",
};

export const ADVANTAGES = [
	{
		icon: 'wallet',
		text: 'Рассрочка'
	},
	{
		icon: 'like',
		text: 'Улучшим любое предложение'
	},
	{
		icon: 'car',
		text: 'Гарантия 5 лет'
	},
];

export const GIFTS = [
	{
		//icon: GIFTS_ICONS["../images/icons/gifts/shield.svg"].default,
		icon: 'shield',
		text: 'Каско <b>в подарок</b>'
	},
	{
		icon: 'tires',
		text: 'Зимняя резина'
	},
	{
		icon: 'gift',
		text: 'ТО <b>в подарок</b>'
	},
	{
		icon: 'key',
		text: 'Сигнализация <br/>с автозапуском'
	},
	{
		icon: 'card',
		text: 'Кэшбек на карту<br/> Автомир'
	},
];

export const GIFTS_LIST = [
	'Бронь капота, крыши <br/>и других уязвимых мест',
	'Антикоррозийная защита',
	'Защита радиатора',
	'Защита картера',
	'Брызговики',
	'Коврики',
	'Тонировка'
];
